// Consumer mailbox domains documented by each provider. Match exact domains;
// custom domains and lookalikes must never inherit a provider's eligibility.
// Google: https://support.google.com/mail/answer/81126
// Microsoft: https://support.microsoft.com/en-us/accounts-billing/manage/how-to-add-an-email-address-or-phone-number-to-your-microsoft-account
// Apple: https://support.apple.com/en-us/118230
// Yahoo: https://help.yahoo.com/kb/SLN3407.html
// Tencent: https://mail.qq.com
// NetEase: https://help.mail.126.com/faq.do?categoryID=44&m=list
export const COMMENT_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'yahoo.com',
  'ymail.com',
  'rocketmail.com',
  'yahoo.co.uk',
  'yahoo.fr',
  'qq.com',
  '163.com',
  '126.com',
  'yeah.net',
] as const;

const domains = new Set<string>(COMMENT_EMAIL_DOMAINS);

export function isAllowedCommentEmail(email: string | null | undefined) {
  if (!email) return false;
  const match = /^[^\s@]+@([^\s@]+)$/.exec(email.trim().toLowerCase());
  return !!match && domains.has(match[1]!);
}
